<template>
  <el-dialog
      width="1200px"
      class="abow_dialog"
      title="修改"
      :visible.sync="dialogVisible"
      append-to-body
      @close="close">
    <div>
      <el-table ref="filterTable" style="width: 100%" :data="tableData">
        <el-table-column prop="materialNo" label="SAP物料代码" align="center"/>
        <el-table-column prop="materialDesc" label="名称型号规格" align="center" width="260"/>
        <el-table-column prop="quantity" label="冲账数量" align="center" width="80"/>
        <el-table-column prop="backTime" label="退回时间" align="center"/>
        <el-table-column prop="offsetTime" label="冲账时间" align="center"/>
        <el-table-column prop="offsetOrderNo" label="冲账订单号" align="center"/>
        <el-table-column label="取消冲账" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="offsetCancel(scope.row)">取消冲账</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "BillTaskRevise",
    data() {
      return {
        dialogVisible: false,
        tableData: [],
        pkid: "",
      };
    },
    methods: {
      open(id) {
        console.log(id);
        // this.pkid = id
        this.dialogVisible = true;
        if (id > 0) {
          this.getData(id);
        }
      },
      getData(id) {
        this.$http.get("basic", `replacementBills/getOffsetListByID/${id}`).then(res => {
          console.log(res);
          this.tableData = res || {};
        });
      },
      offsetCancel(row) {
        this.$http.post("basic", "replacementBills/offsetCancel", row).then(() => {
          this.$message.success("取消冲账成功");
          this.$router.push({path: "/afterSalesManagement/BillTask/TaskList"});
          this.$emit("save-success");
          this.dialogVisible = false;
        });
      },
      close() {
      },
    },
  };
</script>
<style lang="css">
.el-dialog__header {
  background: #f8f8f8;
  padding-top: 15px;
}

.el-dialog__title {
  font-size: 16px;
}

.el-dialog .el-dialog__footer {
  border-top: 1px solid #f3f3f3;
  padding: 20px 15px 10px;
}
</style>
